import React, { useState, useEffect } from 'react';
import './AgeGate.css';

const AGE_GATE_STORAGE_KEY = 'goldenPour_ageVerified';

const AgeGate = ({ onVerified }) => {
  const [isVerified, setIsVerified] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    // Check if user has already verified
    const verified = localStorage.getItem(AGE_GATE_STORAGE_KEY);
    if (verified === 'true') {
      setIsVerified(true);
      if (onVerified) {
        onVerified();
      }
    }
  }, [onVerified]);

  const handleYes = () => {
    localStorage.setItem(AGE_GATE_STORAGE_KEY, 'true');
    setIsVerified(true);
    if (onVerified) {
      onVerified();
    }
  };

  const handleNo = () => {
    setIsBlocked(true);
  };

  // Don't render if already verified
  if (isVerified) {
    return null;
  }

  return (
    <div className="age-gate" role="dialog" aria-modal="true" aria-labelledby="age-gate-title">
      <div className="age-gate__overlay"></div>
      <div className="age-gate__content">
        {!isBlocked ? (
          <>
            <h1 id="age-gate-title" className="age-gate__title">Are you 18 or above?</h1>
            <p className="age-gate__subtitle">
              You must be 18 years or older to access this website.
            </p>
            <div className="age-gate__actions">
              <button
                className="age-gate__btn age-gate__btn--yes"
                onClick={handleYes}
                autoFocus
              >
                Yes, I am 18+
              </button>
              <button
                className="age-gate__btn age-gate__btn--no"
                onClick={handleNo}
              >
                No
              </button>
            </div>
          </>
        ) : (
          <>
            <h1 className="age-gate__title">Access Restricted</h1>
            <p className="age-gate__subtitle">
              You must be 18 years or older to access this website.
            </p>
            <p className="age-gate__message">
              Thank you for your honesty. This website contains content intended for adults only.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AgeGate;
